import { some } from "lodash";
import { useActivitystreams } from "../api/activitystreams.ts";

export function useCanWriteToAnyStream() {
  const { data: activitystreams } = useActivitystreams();

  if (!activitystreams) return false;

  return some(activitystreams, (stream) => stream && stream.can?.create);
}
